import { isWeb } from '@gluestack-ui/nativewind-utils/IsWeb';

/**
 * Lets a reader copy clinical text on native, where `Text` is not selectable by
 * default. Omitted on web: text there is already selectable, and the web `Text`
 * renders a `span` that would pass `selectable` through as an invalid attribute.
 */
export const SELECTABLE_TEXT_PROPS: { selectable?: boolean } = isWeb ? {} : { selectable: true };
